/** Hindi: Talk's and Find's chats: the list of past chats, a new chat, and deleting one. */
export const chats = {
    "chats.new": "नई चैट",
    "chats.title": "आपकी चैट",
    "chats.today": "आज",
    "chats.yesterday": "कल",
    "chats.earlier": "पहले की",
    "chats.empty": "अभी कोई पुरानी चैट नहीं। हर चैट यहीं, इस फ़ोन पर रखी जाती है।",
    "chats.kept": "सिर्फ़ इस फ़ोन पर। सबसे नई {count} चैट रखी जाती हैं; यहाँ कोई और साइन इन करे तो उसे इनमें से कुछ नहीं दिखता।",
    "chats.untitled": "बिना नाम की चैट",
    "chats.card_waiting": "आपका कार्ड अधूरा है",
    "chats.delete": "मिटाएँ",
    "chats.delete_label": "चैट मिटाएँ: {title}",
    "chats.delete_confirm": "यह चैट मिटाएँ? यह इस फ़ोन से हमेशा के लिए हट जाएगी।",
    "chats.delete_confirm_card": "यह चैट मिटाएँ? यह इस फ़ोन से हट जाएगी, आपके अधूरे कार्ड के जवाबों के साथ।",
    "chats.delete_yes": "मिटाएँ",
    "chats.keep": "रहने दें",
    "chats.need_unsent": "अभी कामगारों को नहीं भेजा",
    "chats.delete_confirm_sent": "यह चैट मिटाएँ? यह इस फ़ोन से हमेशा के लिए हट जाएगी; इसका काम 'मेरे काम' में रहेगा।",
    "chats.new_need": "कुछ और माँगें",
};
//# sourceMappingURL=chats.js.map